<template>

</template>

<script>
export default {
  name: "UsageRate"
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// UsageRate.vue?8deb70b6